module.exports = __webpack_public_path__ + "689aab37e09466a7c3c984ed4d20cfbb.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/mouth-bold.svg
// module id = DJ3I
// module chunks = 0